export enum CustomDateRange {
    Custom = 'custom',
    Today = 'today',
    Yesterday = 'yesterday',
    ThisWeek = 'this-week',
    ThisMonth = 'this-month',
    LastWeek = 'last-week',
    LastMonth = 'last-month',
    Last7Days = 'last-7-days',
    Last30Days = 'last-30-days',
}